import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class MenuFooter extends Component {

    generateMenuFooter = (menuFooters) => {
        return menuFooters.map((menuFooter, index) => {
            let slug = menuFooter.slug ? menuFooter.slug : "";
            return (
                <li key={index}><Link to={`/${slug}`}>{menuFooter.title}</Link></li>
            )
        })
    }

    render() {
        if (this.props.getMenuFooters.loading) {
            return 'MenuFooter Loading...'
        };
        if (this.props.getMenuFooters.error) {
            return 'MenuFooter Error fetch data';
        }
        let menuFooters = this.props.getMenuFooters.getMenuFooters;

        return (
            <div className="footer-menu">
                <div className="container">
                    <div className="clearfix">
                        <div className="pull-left">
                            <ul className="list-inline marginB0 list-menu">
                                {this.generateMenuFooter(menuFooters)}
                            </ul>
                        </div>
                        <div className="pull-right">
                            <ul className="list-inline marginB0 list-social">
                                <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><span className="fa fa-facebook" /></a></li>
                                <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><span className="fa fa-twitter" /></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default MenuFooter;



// WEBPACK FOOTER //
// ./src/components/MenuFooter.js